import { CommonModule } from '@angular/common';
import { Component, inject, Input, signal } from '@angular/core';
import { AnnouncementService } from '../../service/announcement.service';
import { SharedModule } from '../../Module/shared.module';

@Component({
  selector: 'app-ads',
  imports: [CommonModule, SharedModule],
  templateUrl: './ads.component.html',
  styleUrl: './ads.component.css'
})
export class AdsComponent {
  @Input() imageSrc: string = '';
  @Input() altText: string = 'Advertisement';
  @Input() containerClass: string = 'ad-space';
  @Input() showSpacing: boolean = true;
  @Input() height: string = 'auto';

  @Input() pageId!: number;
  @Input() sectionId?: number;
  // @Input() fallbackImage: string = 'images/ad/1600.250.png';


  // ad = signal<any | null>(null);

  // private announcementService = inject(AnnouncementService);

  // ngOnInit(): void {
  //   this.loadAd();
  // }

  // private loadAd() {
  //   this.announcementService.getDetectedAnnouncements({
  //     PageId: this.pageId,
  //     SectionId: this.sectionId
  //   }).subscribe({
  //     next: (res: any) => {
  //       this.ad.set(res.value?.[0] ?? null);
  //     }
  //   });
  // }
}
